//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowBranch(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11 5L9 3H3V9L5 11V6.41L11 12.41V21H13V11.59L6.41 5H11Z" fill="currentColor" /><path d="M15 3L13 5H17.59L13.29 9.29L14.71 10.71L19 6.41V11L21 9V3H15Z" fill="currentColor" /></svg>;
}
export default IconArrowBranch;